<template>
    <v-card>
        <v-card-title>
            Lista de Productos
            <v-spacer></v-spacer>
            <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar producto..." outlined dense
                hide-details></v-text-field>
        </v-card-title>
        <div style="max-height: 400px; overflow-y: auto;">
            <v-data-table :headers="headers" :items="listProducts" :search="search">
                <template v-slot:item.name="{ item }">
                    <v-list-item class="px-0">
                        <v-list-item-avatar class="rounded-0" height="60" width="60">
                            <v-img :src="item.banner" aspect-ratio="1.7" contain></v-img>
                        </v-list-item-avatar>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ item.name }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </template>
                <template v-slot:item.type="{ item }">
                    <span>{{ (item.type == 'service') ? 'Servicio' : 'Producto' }}</span>
                </template>
                <template v-slot:item.categories="{ item }">
                    <ul>
                        <li v-for="(cat, m) in item.categories" :key="m">
                            {{ cat.name }}
                        </li>
                    </ul>
                </template>
                <template v-slot:item.quantity="{ item }">
                    <div class="d-flex align-center justify-center">
                        <v-btn icon small @click="changePlusAndMinusTable('minus', item.index)" :disabled="item.quantity <= 0">
                            <v-icon dark>
                                mdi-minus
                            </v-icon>
                        </v-btn>
                        <v-text-field placeholder="Cantidad" color="primary" outlined dense type="number" min="1" step="1"
                            :max="stock" hide-details v-model="item.quantity" style="width:100px;max-width:100px;"
                            class="text-center in-center" @input="changeQuantityTable($event, item.index)"
                            :disabled="true"
                            ></v-text-field>
                        <v-btn icon small @click="changePlusAndMinusTable('plus', item.index)"
                            :disabled="item.quantity >= stock">
                            <v-icon dark>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </div>
                </template>
                <template v-slot:item.price="{ item }">
                    <!--  <span class="title" v-if="item.price">
                        <v-text-field placeholder="Precio" color="primary" outlined dense type="number" min="1" hide-details
                            v-model="item.subtotal" style="width:100px;max-width:100px;" class="text-center in-center"
                            @input="changePriceCall($event, item.index)" v-if="changePrice">
                            <template v-slot:prepend>
                                <span>{{ money }}</span>
                            </template>
        </v-text-field>
        <span v-else>
            {{ money }} {{ (item.quantity > 0) ? (item.price * item.quantity) : item.price }}
        </span>
        </span> -->
                </template>
            </v-data-table>
        </div>
        <div style="padding: 10px 10px;text-align: right;">
            <v-btn
                color="danger"
                @click="selectedProds = []; close()"
            >
                Cancelar
            </v-btn>
            <v-btn
                color="primary"
                @click="addToCartPresale()"
            >
                Aceptar
            </v-btn>
        </div>
    </v-card>

</template>

<script>
export default {
    components: {

    },
    props: ['slug', 'onAddProduct','close'],
    data() {
        return {
            page: 1,
            search: '',
            txtSearch: '',
            listProducts: [],
            stock: 500,
            headers: [
                {
                    text: 'Producto',
                    align: 'start',
                    sortable: false,
                    value: 'name',
                },
                { text: 'Tipo', value: 'type' },
                { text: 'Categoría', value: 'categories' },
                { text: 'Cantidad', align: 'center', value: 'quantity' },
                { text: 'Precio', value: 'price' }
            ],
            selectedProds: []
        };
    },
    mounted() {
        this.getListProducts()
    },
    methods: {
        async getListProducts() {
            this.overlay = true
            await axios.post(`/preventist/list-products?page=${this.page}&search=${this.txtSearch}&slug=${this.slug}`, {})
                .then(response => {
                    // console.log(response)
                    let tempCart = (localStorage.getItem(this.slug)) ? JSON.parse(localStorage.getItem(this.slug)) : {}
                    this.listProducts = response.data
                    this.listProducts.forEach((element, i) => {
                        element.index = i
                        element.quantity = (tempCart[i]) ? tempCart[i].quantity : 0
                        element.subtotal = (tempCart[i]) ? tempCart[i].price : element.price
                    });
                    // this.listProducts = response.data.data
                    // this.totalPage = response.data.last_page
                    // this.pageTable = `Mostrando <strong>${response.data.from??0} - ${response.data.to??0}</strong> de un total de <strong>${response.data.total}</strong>`
                    //this.overlay = false
                })
                .catch(error => {
                    // console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.overlay = false
                })
        },
        changePlusAndMinusTable(type, i) {
            let tmpImport = 0
            switch (type) {
                case 'minus':
                    tmpImport = ((+this.listProducts[i].price) * ((+this.listProducts[i].quantity) - 1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    this.listProducts[i].quantity = (+this.listProducts[i].quantity) - 1
                    break
                case 'plus':
                    tmpImport = ((+this.listProducts[i].price) * ((+this.listProducts[i].quantity) + 1))
                    if (tmpImport < 0) {
                        this.$notify.error('Error, el importe esperado no debe ser menor a cero, revise el campo descuento por favor.')
                        return
                    }
                    // this.$set(this.listProducts[i], 'quantity', (+this.listProducts[i].quantity) + 1)
                    this.listProducts[i].quantity = (+this.listProducts[i].quantity) + 1
                    break
                default:
                    break
            }
            this.listProducts = [...this.listProducts]
            // this.changeQuantity(this.listProducts[i].quantity)
            if (this.listProducts[i].quantity > 0) {
                this.prodId = this.listProducts[i].id
                this.nameProd = this.listProducts[i].name
                this.typeProd = this.listProducts[i].type
                this.price = (this.listProducts[i].special_price) ? this.listProducts[i].special_price : this.listProducts[i].price
                this.quantity = this.listProducts[i].quantity
                this.tmpIndex = i
                this.listProducts[i].subtotal = this.listProducts[i].price * this.listProducts[i].quantity
                this.subtotal = this.listProducts[i].price * this.listProducts[i].quantity

                if (localStorage.getItem(this.slug)) {
                    //this.updateToCart()
                } else {
                    //this.addToCart()
                    let selProd = this.selectedProds.find(a => a.id === this.listProducts[i].id);
                    if(!selProd) {
                        this.selectedProds = [
                            ...this.selectedProds,
                            this.listProducts[i]
                        ];
                    } else {
                        this.selectedProds = this.selectedProds.map((prod) => {
                            if(prod.id === this.listProducts[i].id) { return this.listProducts[i]; }
                            return prod;
                        });
                    }
                }
            } else {
                //this.removeItemOfCartTable(i)
            }
        },
        changeQuantityTable(event, i) {
            if (+event > this.stock) {
                this.$fire({
                    title: 'Agotado',
                    text: `Stock agotado, solo queda ${this.stock} productos en almacén`,
                    type: 'error',
                    confirmButtonText: 'Entendido',
                    confirmButtonColor: this.primary,
                    cancelButtonColor: '#f44336',
                    reverseButtons: true,
                    showCancelButton: false,
                    customClass: {
                        container: this.fontFamily
                    }
                }).then(resp => {
                    if (resp.value) {
                        this.listProducts[i].quantity = this.stock
                        // this.calcTotal()
                    }
                })
            }
            this.listProducts = [...this.listProducts]
            if (this.listProducts[i].quantity > 0) {
                this.prodId = this.listProducts[i].id
                this.nameProd = this.listProducts[i].name
                this.typeProd = this.listProducts[i].type
                this.price = (this.listProducts[i].special_price) ? this.listProducts[i].special_price : this.listProducts[i].price
                this.quantity = this.listProducts[i].quantity
                this.tmpIndex = i
                this.listProducts[i].subtotal = this.listProducts[i].price * this.listProducts[i].quantity
                this.subtotal = this.listProducts[i].price * this.listProducts[i].quantity
                if (localStorage.getItem(this.slug)) {
                    //this.updateToCart()
                } else {
                    //this.addToCart()
                }
            } else {
                //this.removeItemOfCartTable(i)
            }
        },
        addToCartPresale() {
            this.onAddProduct(this.selectedProds);
            this.close();
        }
    },
}
</script>
